import { DateTime } from 'luxon';

export function today_at_time(hour, zone) {
  return DateTime.fromObject({ hour, zone });
}

export function now(zone) {
  return DateTime.fromObject({ zone });
}

export function next_time_it_is(hour, zone) {
  const date = today_at_time(hour, zone);
  return date < now(zone)
    ? date.plus({ day: 1 })
    : date;
}

export function hours_in_timezone(date, zone) {
  return DateTime.fromISO(date).setZone(zone).get('hour');
}

// to make sure date is sometime in the future
export function snap_forward(date, zone) {
  const date_object = DateTime.fromISO(date).setZone(zone);
  return date_object < now(zone)
    ? next_time_it_is(hours_in_timezone(date, zone), zone)
    : date_object;
}

export function user_timezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return 'America/New_York';
  }
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Settings/DocketAlertTimeCalculations.js